import { CMS_Content_Module_Text_Image } from './types';
import { Button, Heading, Image } from '@cue/atoms';
import { StyledComponent } from '@cue/theme';
import { Mdx } from '@cue/utility';
import styled, { CSSObject } from '@emotion/styled';
import React from 'react';

type TextImageContentModuleProps = CMS_Content_Module_Text_Image['data'];

export const TextImageContentModule: React.FC<
  TextImageContentModuleProps &
    StyledComponent<TextImageContentModuleCSSOverride> & { onClick?: () => void }
> = (props) => {
  const {
    text,
    headline,
    image,
    label,
    link_text,
    link_url,
    orientation,
    flip_direction,
    button_icon,
    button_style,
    customFooter,
    onClick: onClickOverride,
  } = props;

  const onClick = (link_url: string) => {
    const hashRegex = /#(.*)/;
    const match: RegExpMatchArray | null = link_url.match(hashRegex);
    if (match) {
      // The hash is in the first capturing group (index 1)
      const hash: string = match[1];
      const el = document?.getElementById(`${hash}`);
      if (el) {
        window.scrollTo({
          behavior: 'smooth',
          top: el.getBoundingClientRect().top - document.body.getBoundingClientRect().top,
        });
      }
    } else {
      window.location.href = link_url;
    }
  };

  return (
    <Container
      className={`cue-text-image-content-module cue-text-image-content-module--${orientation} ${
        flip_direction ? 'cue-text-image-content-module--flipped' : ''
      } ${link_text || link_url || onClickOverride ? ' cue-text-image-content-module-has-link' : ''}`}
      onClick={() => (onClickOverride ? onClickOverride() : link_url && onClick(link_url || ''))}>
      <div className="cue-text-image-content-module__image">
        {image && <Image src={image} className="cue-text-image-content-module-image" />}
      </div>
      <div className="cue-text-image-content-module__content">
        <div className="cue-text-image-content-module__text">
          {headline && (
            <Heading type="h4" className="cue-text-image-content-module-headline">
              {headline}
            </Heading>
          )}
          {text && <Mdx css_class={'cue-text-image-content-module-text'}>{text}</Mdx>}
          {link_url || label || link_text || customFooter ? (
            <div className="cue-text-image-content-module-footer">
              {label && (
                <div className="cue-text-image-content-module-label">
                  <Label className="cue-text-image-content-module-label">{label}</Label>
                </div>
              )}
              {link_text || link_url ? (
                <div className="cue-text-image-content-module-link">
                  {link_url ? (
                    <Button
                      onClick={() => {
                        onClick(link_url);
                      }}
                      icon={button_icon?.component || undefined}
                      styling={button_style || ''}>
                      {link_text}
                    </Button>
                  ) : (
                    <span>{link_text}</span>
                  )}
                </div>
              ) : null}
              {customFooter ? customFooter() : null}
            </div>
          ) : null}
        </div>
      </div>
    </Container>
  );
}; /* <a href={link_url}>{link_text} {button_style}</a> */

const Container = styled.div``;
const Label = styled.div``;
export type TextImageContentModuleCSSOverride = {
  '.cue-text-image-content-module'?: CSSObject;
  '.cue-text-image-content-module-image'?: CSSObject;
  '.cue-text-image-content-module-headline'?: CSSObject;
  '.cue-text-image-content-module-text'?: CSSObject;
  '.cue-text-image-content-module-label'?: CSSObject;
};
